module.exports = __webpack_public_path__ + "static/media/bannerDesktop@1x.c9f6549d.jpg";